import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ODENTIS] Erreur de rendu :', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <h1 style={styles.title}>Une erreur est survenue</h1>
            <pre style={styles.message}>{String(this.state.error?.message || this.state.error)}</pre>
            <p style={styles.stack}>{String(this.state.error?.stack || '')}</p>
            <button style={styles.btn} onClick={() => { this.setState({ error: null }); window.location.href = '/'; }}>
              Recharger l'application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: 24 },
  card: { background: '#fff', borderRadius: 12, padding: 32, maxWidth: 560, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' },
  title: { fontSize: 22, fontWeight: 700, color: '#dc2626', marginBottom: 16 },
  message: { background: '#fef2f2', color: '#b91c1c', padding: 12, borderRadius: 8, fontSize: 14, whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  stack: { marginTop: 12, fontSize: 12, color: '#64748b', maxHeight: 200, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  btn: { marginTop: 20, padding: '12px 20px', background: '#2563eb', color: '#fff', fontWeight: 600, borderRadius: 8, fontSize: 14 },
};